import { showTodoPanelWithSubject } from '../actions/showTodoPanelAction';
import { isFeatureEnabled } from 'owa-feature-flags';
import { LazyInitializeQuickAdd } from 'owa-todos';
import { isTodoPanelAvailable } from 'owa-todos/lib/utils/isTodoPanelAvailable';
import { trace } from 'owa-trace';
import { tryTodoPanel } from 'owa-whats-new/lib/actions/tryTodoPanel';
import { orchestrator } from 'satcheljs';

export default orchestrator(showTodoPanelWithSubject, actionMessage => {
    const shouldShowTodoPanel = isTodoPanelAvailable() && isFeatureEnabled('mc-smartTask');
    if (shouldShowTodoPanel) {
        // Update the todo pane store so the quickAdd item is already populated
        LazyInitializeQuickAdd.importAndExecute(
            actionMessage.subject,
            actionMessage.messageId,
            actionMessage.extractionId
        );
        tryTodoPanel();
    } else {
        trace.info(
            '[showTodoPanelWithSubject] Todo panel is not shown for shadow mailbox or feature flight is disabled.'
        );
    }
});
